import { Grid } from '@mantine/core';
import { PodcastGridProps } from './types';
import { FC, Fragment } from 'react';
import { PodcastCard } from '@molecules/frontoffice/PodcastCard';
import { InView } from 'react-intersection-observer';
import { RandomPublicityComponent } from '@organisms/RandomPublicityComponent';

const PUBLICITY_INDEX = 3;

export const PodcastGrid: FC<PodcastGridProps> = ({
  podcasts,
  hasNextPage,
  fetchNextPage,
  publicities,
}) => {
  const hasSidebarPublicity = publicities?.some((p) => p.type === 'SIDEBAR');

  return (
    <Grid columns={12} gutter="md">
      {podcasts?.map((podcast, index) => (
        <Fragment key={podcast.id}>
          {index === PUBLICITY_INDEX && hasSidebarPublicity && (
            <Grid.Col span={12} md={4} lg={3}>
              <RandomPublicityComponent
                index={0}
                type="SIDEBAR"
                publicities={publicities ?? []}
              />
            </Grid.Col>
          )}
          <Grid.Col span={12} md={4} lg={3}>
            {podcasts.length - 1 === index ? (
              <InView
                as="div"
                style={{ padding: 0, margin: 0 }}
                onChange={(inView) => {
                  if (hasNextPage && inView && podcasts.length - 1 === index) {
                    fetchNextPage();
                  }
                }}
                threshold={0.8}
              >
                <PodcastCard podcast={podcast} />
              </InView>
            ) : (
              <PodcastCard podcast={podcast} />
            )}
          </Grid.Col>
        </Fragment>
      ))}
    </Grid>
  );
};
